import React, { Fragment } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import RewriteUrlComponent from '../components/RewriteUrlComponent';
import PostDetail from 'pages/postDetail/index';
import PostDetailProvider from 'containers/PostDetailProvider';
import ModalViewImagePage from '../pages/ModalViewImagePage';

function PostsRoutes() {
  const location = useLocation();
  const state = location.state;

  return (
    <Fragment>
      <Routes>
        <Route path="/tin/:postId" element={<PostDetail />} />
        <Route path="/tin" element={<PostDetailProvider />}>
          <Route path=":postId/i/:imageId" element={<ModalViewImagePage />} />
        </Route>
        <Route path="/p/:postId" element={<RewriteUrlComponent />} />
        <Route path="/p" element={<PostDetailProvider />}>
          <Route path=":postId/i/:imageId" element={<RewriteUrlComponent />} />
        </Route>
      </Routes>

      {state?.backgroundLocation && (
        <Routes>
          <Route path="/p" element={<PostDetailProvider />}>
            <Route path=":postId/i/:imageId" element={<RewriteUrlComponent />} />
          </Route>
          <Route path="/tin" element={<PostDetailProvider />}>
            <Route path=":postId/i/:imageId" element={<ModalViewImagePage />} />
          </Route>
        </Routes>
      )}
    </Fragment>
  );
}

export default PostsRoutes;
